import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PostPay() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [orderId, setOrderId] = useState('');

  const handleChangeLanguage = e => {
    i18n.changeLanguage(e.target.value);
  };

  const handleNavigateLandingPage = () => {
    navigate('../lp');
  };

  useEffect(() => {
    setOrderId(window.location.search.split('&')[0].split('=')[1]);
  }, []);

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-white fixed-top navbar-custom'>
        <div className={`${i18n.language === 'ar' ? 'flex-row-reverse' : ''} container-fluid`}>
          <div className='col-2 text-center mx-auto' onClick={handleNavigateLandingPage}>
            <img src='/Sobol_logo.png' alt='Sobol Logo' height={'50px'} role='button' />
          </div>
          <div
            className={`${
              i18n.language === 'ar' ? 'offset-1 text-start' : 'offset-9 text-end '
            } col d-flex`}>
            <select
              className={`d-inline-block landing-page__button text-center py-2`}
              role={'button'}
              onChange={handleChangeLanguage}>
              <option className='bg-white text-primary' value='en'>
                En
              </option>
              <option className='bg-white text-primary' value='ar'>
                Ar
              </option>
            </select>
          </div>
        </div>
      </nav>
      <div className='container'>
        <div className='row p-auto mt-5 mb-2'>
          <img
            src='/Sobol_logo.png'
            alt='Sobol Logo'
            className='mx-auto'
            style={{ width: '130px' }}
          />
        </div>
        <div className={`${i18n.language === 'ar' ? 'text-end arabic' : 'text-start'} row`}>
          <span className='text-success fs-3 fw-bolder my-2 text-center'>
            {t('postPay.message')}
          </span>
          <span className='text-success fs-3 fw-bolder my-2 text-center'>
            {t('postPay.order')} : {orderId}
          </span>
          <span className='text-dark fs-5 fw-bold my-2 text-center'>
            {t('postPay.emailMessage')}
          </span>
          <ul className='text-secondary fs-6 fw-bold my-2'>
            <li>
              {t('postPay.issuer.title')}{' '}
              <span className='text-dark'>({t('postPay.issuer.description')}).</span>
            </li>
            <li>
              {t('postPay.receiver.title')}{' '}
              <span className='text-dark'>({t('postPay.receiver.description')}).</span>
            </li>
            <li>
              {t('postPay.pin.title')}{' '}
              <span className='text-dark'>({t('postPay.pin.description')}).</span>
            </li>
            <li>
              {t('postPay.api.title')}{' '}
              <span className='text-dark'>({t('postPay.api.description')}).</span>
            </li>
          </ul>
          <div className='row justify-content-center m-0 fs-5'>
            <div className='btn btn-md btn-success my-2' style={{ width: '130px' }}>
              <a
                href={`mailto:info@ssobol.com?subject=Required paperwork, order id : ${orderId}`}
                className='text-decoration-none text-light'>
                {t('postPay.button')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PostPay;
